// eslint-disable-next-line import/prefer-default-export
export enum ActionTypes {
  TOGGLE_EDIT_MODE = "TOGGLE_EDIT_MODE",
}
